import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { 
  Heart, 
  Share2, 
  Volume2, 
  VolumeX, 
  MapPin, 
  Box, // Box icon for 3D/Virtual Tour alternative
  ChevronRight,
  Info
} from 'lucide-react';

// Test verileri - Gerçek projede backend'den veya props'tan gelecek.
// Not: İnternette doğrudan erişilebilir, hızlı .mp4 linkleri bulmak zor olduğu için
// test amaçlı genel mp4 URL'leri kullanılmıştır.
const REELS_DATA = [
  {
    id: 'r1',
    videoUrl: '/videos/video1.mp4',
    price: '4.250.000 TL',
    location: 'Diyarbakır, Kayapınar',
    title: 'Lüks Havuzlu Villa',
    propertyId: 'p-101',
    hasVirtualTour: true,
    likes: 124,
  },
  {
    id: 'r2',
    videoUrl: 'https://cdn.pixabay.com/vimeo/384789539/house-31122.mp4?width=720&hash=5d54a4f89d34346bb6ccbd2445e99db88b90c377',
    price: '2.850.000 TL',
    location: 'Diyarbakır, Yenişehir',
    title: 'Merkezi Konumda 3+1 Daire',
    propertyId: 'p-102',
    hasVirtualTour: false,
    likes: 85,
  },
  {
    id: 'r3',
    videoUrl: 'https://cdn.pixabay.com/vimeo/156942186/architecture-2309.mp4?width=720&hash=e0f8f8b8cf46e5a6f236ff8512140a7a08e12480',
    price: '6.500.000 TL',
    location: 'Diyarbakır, Sur',
    title: 'Tarihi Dokulu Özel Konak',
    propertyId: 'p-103',
    hasVirtualTour: true,
    likes: 342,
  },
  {
    id: 'r4',
    videoUrl: 'https://cdn.pixabay.com/vimeo/457497746/apartment-48995.mp4?width=720&hash=01a75e3c749eb40375dc11ba0340b6164f9c5780',
    price: '1.950.000 TL',
    location: 'Diyarbakır, Bağlar',
    title: 'Yatırımlık 2+1 Fırsat Daire',
    propertyId: 'p-104',
    hasVirtualTour: false,
    likes: 45,
  }
];

// Tekil Video Bileşeni
const ReelItem = ({ data, isActive, isMuted, toggleMute }) => {
    console.log("GELEN İLAN VERİSİ:", data);
  const videoRef = useRef(null);
  const [isLiked, setIsLiked] = useState(false);
  const [showToast, setShowToast] = useState(false);
  
  // Video oynatma/duraklatma mantığı
  useEffect(() => {
    if (!videoRef.current) return;

    if (isActive) {
      // isActive true ise videoyu oynatmayı dene
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          // Autoplay policy hatalarını yakala (kullanıcı etkileşimi gerekebilir)
          console.warn("Otomatik oynatma engellendi:", error);
        });
      }
    } else {
      // Ekranda değilse durdur ve başa sar
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [isActive]);

  const handleLike = () => {
    setIsLiked(!isLiked);
  };

  const handleShare = async () => {
    try {
      // Modern cihazlar için yerel paylaşım API'si
      if (navigator.share) {
        await navigator.share({
          title: `RefRef Emlak - ${data.title}`,
          text: `${data.title} - ${data.price}`,
          url: `https://refrefemlak.com/ilan/${data.propertyId}`,
        });
      } else {
        // Fallback: Linki kopyala
        await navigator.clipboard.writeText(`https://refrefemlak.com/ilan/${data.propertyId}`);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 2000);
      }
    } catch (error) {
      console.log('Paylaşım hatası:', error);
    }
  };

  const handleGoToAd = () => {
    // Gerçek projede React Router ile yönlendirme yapılacak (örn: history.push veya navigate)
    alert(`${data.title} ilanına yönlendiriliyorsunuz...`);
  };

  const handleGoToVirtualTour = () => {
    alert(`${data.title} için Sanal Tur açılıyor...`);
  };

 return (
    <div className="relative w-full h-full snap-start snap-always bg-black flex items-center justify-center overflow-hidden">
      
      {/* Video Elementi */}
      <video
        ref={videoRef}
        src={
          (data.videoUrl || data.video_path || data.video)?.startsWith('http') 
            ? (data.videoUrl || data.video_path || data.video) 
            : `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000'}/${data.videoUrl || data.video_path || data.video}`
        }
        className="w-full h-full object-contain"
        controls
        loop
        playsInline
        muted={isMuted}
        onClick={toggleMute} // Videoya tıklayınca sesi aç/kapat (TikTok mantığı)
      />

      {/* Üst Katman Gradienti - Alt kısımdaki yazıların okunabilirliğini artırmak için */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80 pointer-events-none" />

      {/* Sağ Yan Etkileşim Butonları (Mobilde takılı kalmaması için hover iptal edildi) */}
      <div className="absolute right-4 bottom-24 flex flex-col items-center space-y-6 z-10">
        <button 
          onClick={handleLike}
          className="flex flex-col items-center transition-transform active:scale-90"
        >
          <div className="p-3 bg-black/40 backdrop-blur-md rounded-full text-white active:bg-black/60 transition-colors">
            <Heart 
              size={28} 
              className={`transition-colors duration-300 ${isLiked ? 'fill-red-500 text-red-500' : 'fill-transparent text-white'}`} 
            />
          </div>
          <span className="text-white text-xs mt-1 font-medium drop-shadow-md">
            {isLiked ? data.likes + 1 : data.likes}
          </span>
        </button>

        <button 
          onClick={handleShare}
          className="flex flex-col items-center transition-transform active:scale-90"
        >
          <div className="p-3 bg-black/40 backdrop-blur-md rounded-full text-white active:bg-black/60 transition-colors">
            <Share2 size={26} className="text-white" />
          </div>
          <span className="text-white text-xs mt-1 font-medium drop-shadow-md">Paylaş</span>
        </button>

        <button 
          onClick={toggleMute}
          className="flex flex-col items-center transition-transform active:scale-90"
        >
          <div className="p-3 bg-black/40 backdrop-blur-md rounded-full text-white active:bg-black/60 transition-colors">
            {isMuted ? <VolumeX size={26} /> : <Volume2 size={26} />}
          </div>
          <span className="text-white text-xs mt-1 font-medium drop-shadow-md">
            {isMuted ? 'Sessiz' : 'Sesli'}
          </span>
        </button>
      </div>

      {/* Sol Alt İlan Detayları ve Yönlendirme Butonları (Genişlik sınırlandırıldı) */}
      <div className="absolute left-0 bottom-4 p-4 w-[75%] sm:w-[70%] z-10 flex flex-col gap-3">
        
        {/* Detay Kartı (Metin maks 3 satıra sınırlandırıldı) */}
        <div className="bg-black/40 backdrop-blur-md rounded-xl p-3 border border-white/10 shadow-lg">
          <h3 className="text-white font-bold text-[15px] sm:text-lg leading-snug mb-1.5 line-clamp-3">
            {data.title}
          </h3>
          
          <div className="flex items-center text-gray-200 text-sm mb-2">
            <MapPin size={14} className="mr-1 flex-shrink-0" />
            <span className="truncate">{data.location}</span>
          </div>
          
          <div className="text-emerald-400 font-extrabold text-xl">
            {data.price}
          </div>
        </div>

        {/* Aksiyon Butonları (Yan Yana) */}
        <div className="flex gap-2">
          <button 
            onClick={handleGoToAd}
            className="flex-1 bg-yellow-500 hover:bg-yellow-400 text-black py-2.5 px-3 rounded-lg flex items-center justify-center gap-1.5 transition-all active:scale-95 text-xs sm:text-sm font-bold shadow-[0_4px_12px_rgba(0,0,0,0.3)]"
          >
            <Info size={16} />
            <span className="truncate">İlana Git</span>
            <ChevronRight size={16} className="-ml-1" />
          </button>

           { data.virtualTourLink && (
          <button
            onClick={() => window.open(data.virtualTourLink, '_blank')}
            className="flex-1 bg-gradient-to-r from-blue-600/80 to-purple-600/80 hover:from-blue-500 hover:to-purple-500 text-white py-2.5 px-3 rounded-xl flex items-center justify-center transition-all duration-300 shadow-lg group relative overflow-hidden"
          >
              {/* Parlama Efekti */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-[shimmer_2.5s_infinite]" />
              
              <Box size={16} className="relative z-10" />
              <span className="truncate relative z-10 text-xs sm:text-sm ml-1">3D Tur</span>
            </button>
          )}
        </div>
      </div>

      {/* Link Kopyalandı Toast Mesajı */}
      {showToast && (
        <div className="absolute top-10 left-1/2 -translate-x-1/2 bg-white text-black px-4 py-2 rounded-full font-medium text-sm shadow-xl z-50 animate-bounce">
          Link kopyalandı!
        </div>
      )}
    </div>
  );
};
export default function EmlakReels() {
  const [reels, setReels] = useState([]);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const [isGlobalMuted, setIsGlobalMuted] = useState(true);

  useEffect(() => {
    const fetchReels = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
        const response = await axios.get(`${apiUrl}/api/reels`);
        
        setReels(response.data);
        
        if (response.data && response.data.length > 0) {
          setActiveVideoId(response.data[0]._id || response.data[0].id);
        }
      } catch (error) {
        console.error("Reels videoları çekilirken hata oluştu:", error);
      }
    };

    fetchReels();
  }, []);
  
  // Container referansı
  const containerRef = useRef(null);
  // Video elementlerinin referanslarını tutmak için
  const videoRefs = useRef(new Map());

  // Intersection Observer Kurulumu
  useEffect(() => {
    // Observer opsiyonları: Elemanın %60'ı ekranda göründüğünde tetikle
    const options = {
      root: containerRef.current,
      rootMargin: '0px',
      threshold: 0.6
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Ekranda büyük oranda görünen videonun ID'sini aktif yap
          const videoId = entry.target.getAttribute('data-reel-id');
          if (videoId) {
            setActiveVideoId(videoId);
          }
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    // Map'teki tüm DOM elementlerini gözlemlemeye başla
    videoRefs.current.forEach((element) => {
      if (element) {
        observer.observe(element);
      }
    });

    // Cleanup fonksiyonu
    return () => {
      observer.disconnect();
    };
  }, []);

  const toggleGlobalMute = () => {
    setIsGlobalMuted(prev => !prev);
  };

  return (
    // Ana konteyner: Ekranı tam kaplar, dikey kaydırmaya (snap-y) izin verir, scrollbar'ı gizler.
    // h-[100dvh] mobil cihazlarda adres çubuğu hesaba katılarak tam ekran yüksekliği sağlar.
    <div className="w-full h-[100dvh] bg-black relative">
      
      {/* Üst Bilgi / Header (Opsiyonel) */}
      <div className="absolute top-0 w-full p-4 z-20 flex justify-between items-center pointer-events-none">
        <h1 className="text-white font-bold text-xl drop-shadow-md">RefRef Reels</h1>
      </div>

      {/* Kaydırılabilir Alan */}
      <div 
        ref={containerRef}
        className="w-full h-full overflow-y-scroll snap-y snap-mandatory hide-scrollbar"
        style={{
          /* Scrollbar gizleme için cross-browser CSS */
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
        }}
      >
        <style dangerouslySetInnerHTML={{__html: `
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          @keyframes shimmer {
            100% { transform: translateX(100%); }
          }
        `}} />

        {reels.map((reel) => (
          <div 
            key={reel.id}
            data-reel-id={reel.id}
            // DOM elementini ref Map'ine ekle
            ref={(el) => {
              if (el) videoRefs.current.set(reel.id, el);
              else videoRefs.current.delete(reel.id);
            }}
            className="w-full h-full snap-center"
          >
            <ReelItem 
              data={reel} 
              isActive={activeVideoId === reel.id}
              isMuted={isGlobalMuted}
              toggleMute={toggleGlobalMute}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
